import React, { useEffect, useMemo } from "react";
import useScript from "../helpers/hooks/useScript";
import Sidebar from "../components/shared/Sidebar";
import RightSidebar from "../components/shared/RightSideBar";
import Topbar from "../components/shared/Topbar";
import { Globals } from "../helpers/globals";

import {
    useHistory,
    BrowserRouter as Router,
    Switch,
    Route,
    Link,
    useParams,
    useRouteMatch,
    useLocation,
} from "react-router-dom";
import EFiling from "../pages/dashboards/EFiling";
import Billing from "../pages/dashboards/Billing";
import System from "../pages/dashboards/System";

import UploadFile from "../pages/upload/UploadFile";
import UploadBatch from "../pages/upload/UploadBatch";

import File from "../pages/queue/File";
import Queue from "../pages/queue";
import Redirect from "../pages/queue/Redirect";

import ExistingCase from "../pages/efile/ExistingCase";
import NewCase from "../pages/efile/NewCase";
import TemplateNewCase from "../pages/efile/TemplateNewCase";
import BatchFile from "../pages/efile/BatchFile";
import DFSUpload from "../pages/efile/DFSUpload";

import OrderUpload from "../pages/efile/Order";

import EFilingReport from "../pages/reporting/EFiling";
import StatusReport from "../pages/reporting/Status";
import RecentReport from "../pages/reporting/Recent";
import SubmissionDetails from "../pages/reporting/submission";

import OrganizationPage from "../pages/admin/organizations";
import UsersPage from "../pages/admin/users";
import AttorneysPage from "../pages/admin/attorneys";
import AttorneyEditPage from "../pages/admin/attorneys/AttorneyEdit";
import OrganizationEditPage from "../pages/admin/organizations/OrganizationEdit";
import FirmsPage from "../pages/admin/firms";
import TylerFirmsPage from "../pages/tyler/admin";
import DivisionRules from "../pages/admin/rules/DivisionRules";
import DocumentTypeRules from "../pages/admin/rules/DocumentTypeRules";
import FeeRules from "../pages/admin/rules/FeeRules";
import CaseTypeRules from "../pages/admin/rules/CaseTypeRules";
import MessageRules from "../pages/admin/rules/MessageRules";
import CaseTypes from "../pages/data/CaseTypes";
import MyCases from "../pages/mycases/MyCases";
import CaseView from "../pages/mycases/CaseView";
import Tags from "../pages/data/Tags";
import { authenticationService } from "../services/authentication.service";
import { EmptyGuid } from "../models";
import Token from "../models/Token";
import { setApiToken } from "../helpers/setupApis";
import SplitFile from "../pages/split/SplitFile";
import Splitter from "../pages/split/Splitting";
import SplittingUi from "../components/shared/splitting/SplittingUi";
import SplittingManager from "../pages/split/components/SplittingManager";
import SubmissionSearch from "../pages/reporting/SubmissionSearch";
import JusticeOfPeaceLocator from "../pages/admin/tools/JusticeOfPeaceLocator";
import UpdateCodes from "../pages/data/UpdateCodes";
import TylerCaseSearch from "../pages/tyler/cases/search";
import Existing from "../pages/tyler/cases/file-into-existing";
import QueueSettings from "../pages/admin/tools/queue";
import CaseExportExecute from "../pages/jobs/case-export/execute";
import AnalyticsPage from "../pages/jobs/autofile/analytics";
import MatterManagmentPage, {
    CreateMatterManagmentPage,
} from "../pages/matterManagement";

export default function AuthLayout() {
    useScript("/assets/js/vendor.min.js");
    useScript("/assets/libs/jquery-knob/jquery.knob.min.js");
    //useScript("/assets/libs/apexcharts/apexcharts.min.js");
    useScript(
        "/assets/libs/admin-resources/jquery.vectormap/jquery-jvectormap-1.2.2.min.js"
    );
    useScript(
        "/assets/libs/admin-resources/jquery.vectormap/maps/jquery-jvectormap-world-mill-en.js"
    );
    //useScript("/assets/js/pages/dashboard-sales.init.js");

    useScript(
        "/assets/libs/twitter-bootstrap-wizard/jquery.bootstrap.wizard.min.js"
    );
    useScript("/assets/libs/dropzone/min/dropzone.min.js");
    useScript("/assets/js/efme.js");
    useScript("/assets/js/app.js");
    useEffect(() => {
        const sideBarSize = localStorage.getItem("sidebar-size");
        document.body.setAttribute("data-layout-mode", "detached");
        document.body.setAttribute(
            "data-layout",
            '{"mode": "light", "width": "fluid", "menuPosition": "fixed", "sidebar": { "color": "gradient", "size": "default", "showuser": true}, "topbar": {"color": "light"}, "showRightSidebarOnPageLoad": true}'
        );
        document.body.setAttribute(
            "data-sidebar-size",
            sideBarSize ?? "default"
        );
        document.body.setAttribute("data-sidebar-color", "gradient");
        document.body.setAttribute("data-layout-width", "fluid");
        document.body.setAttribute("data-layout-menu-position", "fixed");
        document.body.setAttribute("data-sidebar-showuser", "true");
        document.body.setAttribute("data-topbar-color", "light");
    }, []);

    useEffect(() => {
        Globals.retrieveMe();
    }, []);

    const currentUser = Globals.currentUserValue;
    const portal = Globals.portalValue;

    return (
        <>
            <div id="wrapper">
                <Topbar />
                <Sidebar />
                <div className="content-page">
                    <Switch>
                        {currentUser?.role &&
                            currentUser.role.key! >= 100 &&
                            portal && (
                                <Route exact path="/dashboard">
                                    <EFiling />
                                </Route>
                            )}
                        <Route path="/upload/batch">
                            <UploadBatch />
                        </Route>
                        <Route exact path="/uploads">
                            <UploadFile />
                        </Route>
                        <Route path="/dashboard">
                            <EFiling />
                        </Route>
                        <Route path="/matter-managment">
                            <MatterManagmentPage />
                        </Route>
                        <Route path="/create-new-matter">
                            <CreateMatterManagmentPage />
                        </Route>
                        <Route path="/efile/existing/:id">
                            <ExistingCase />
                        </Route>
                        <Route path="/efile/new-case/:id">
                            <NewCase />
                        </Route>
                        <Route path="/efile/template-new-case/:id">
                            <TemplateNewCase />
                        </Route>
                        <Route path="/efile/dfs/:id">
                            <DFSUpload />
                        </Route>
                        <Route path="/efile/order/:id">
                            <OrderUpload />
                        </Route>
                        <Route path="/efile/batch/new/:id">
                            <BatchFile />
                        </Route>
                        <Route path="/efile/batch/existing/:id">
                            <BatchFile />
                        </Route>
                        {currentUser?.role && currentUser.role!.key! >= 100 && (
                            <Route path="/queue/:filter?/:state?">
                                <Queue />
                            </Route>
                        )}
                        <Route path="/efile">
                            <File />
                        </Route>
                        <Route path="/redirect/:submissionId">
                            <Redirect />
                        </Route>
                        <Route path="/preprocess">
                            <Splitter />
                        </Route>
                        <Route path="/data/casetypes">
                            <CaseTypes />
                        </Route>
                        <Route path="/data/updatecodes">
                            <UpdateCodes />
                        </Route>
                        <Route path="/data/tags">
                            <Tags />
                        </Route>
                        <Route path="/reporting/efiling">
                            <EFilingReport />
                        </Route>
                        <Route path="/reporting/status">
                            <StatusReport />
                        </Route>
                        <Route path="/reporting/recent">
                            <RecentReport />
                        </Route>
                        <Route path="/reporting/search">
                            <SubmissionSearch />
                        </Route>
                        <Route path="/reporting/submission/:id">
                            <SubmissionDetails />
                        </Route>
                        <Route path="/pages/mycases">
                            <MyCases />
                        </Route>
                        <Route path="/pages/caseview/:attorneyId/:countyId/:ucn">
                            <CaseView />
                        </Route>
                        {portal && (
                            <Route path="/tyler">
                                <Switch>
                                    <Route path="/tyler/firms">
                                        <TylerFirmsPage />
                                    </Route>
                                    <Route path="/tyler/cases/case-search">
                                        <TylerCaseSearch />
                                    </Route>
                                    <Route path="/tyler/existing/:id">
                                        <Existing />
                                    </Route>
                                    <Route path="/tyler/new/:id">
                                        <Existing />
                                    </Route>
                                </Switch>
                            </Route>
                        )}

                        {currentUser?.role &&
                            (currentUser.role!.key! >= 500 ||
                                currentUser.role!.key! == 60) && (
                                <>
                                    <Route path="/admin">
                                        <Switch>
                                            {currentUser.role!.key! >= 500 && (
                                                <Route path="/admin/rules">
                                                    <Switch>
                                                        <Route path="/admin/rules/divisions">
                                                            <DivisionRules />
                                                        </Route>
                                                        <Route path="/admin/rules/doctypes">
                                                            <DocumentTypeRules />
                                                        </Route>
                                                        <Route path="/admin/rules/fees">
                                                            <FeeRules />
                                                        </Route>
                                                        <Route path="/admin/rules/casetypes">
                                                            <CaseTypeRules />
                                                        </Route>
                                                        <Route path="/admin/rules/messages">
                                                            <MessageRules />
                                                        </Route>
                                                    </Switch>
                                                </Route>
                                            )}
                                            {currentUser.role!.key! >= 500 && (
                                                <Route path="/admin/organizations/:active?">
                                                    <OrganizationPage />
                                                </Route>
                                            )}
                                            {currentUser.role!.key! >= 500 && (
                                                <Route path="/admin/organizationedit/:id">
                                                    <OrganizationEditPage />
                                                </Route>
                                            )}
                                            {currentUser.role!.key! >= 500 && (
                                                <Route path="/admin/firms/:active?">
                                                    <FirmsPage />
                                                </Route>
                                            )}
                                            {currentUser.role!.key! >= 500 && (
                                                <Route path="/admin/split">
                                                    <SplitFile />
                                                </Route>
                                            )}
                                            {currentUser.role!.key! >= 500 && (
                                                <Route path="/admin/document/:s3loc/:filename">
                                                    <Splitter />
                                                </Route>
                                            )}
                                            {currentUser.role!.key! >= 500 && (
                                                <Route path="/admin/case-export">
                                                    <Switch>
                                                        <Route path="/admin/case-export/status">
                                                            <EFiling />
                                                        </Route>
                                                        <Route path="/admin/case-export/execute">
                                                            <CaseExportExecute />
                                                        </Route>
                                                    </Switch>
                                                </Route>
                                            )}
                                            {currentUser.role!.key! >= 500 && (
                                                <Route path="/jobs/auto-file">
                                                    <Switch>
                                                        <Route path="/jobs/auto-file/status">
                                                            <EFiling />
                                                        </Route>
                                                        <Route path="/jobs/auto-file/execute">
                                                            <EFiling />
                                                        </Route>
                                                        <Route path="/jobs/auto-file/analytics">
                                                            <AnalyticsPage />
                                                        </Route>
                                                    </Switch>
                                                </Route>
                                            )}
                                            <Route path="/admin/users/:active?">
                                                <UsersPage />
                                            </Route>
                                            <Route path="/admin/attorneys/:active?">
                                                <AttorneysPage />
                                            </Route>
                                            <Route path="/admin/attorneyedit/:id">
                                                <AttorneyEditPage />
                                            </Route>
                                            <Route path="/admin/jplocator">
                                                <JusticeOfPeaceLocator />
                                            </Route>
                                            <Route path="/admin/queue-settings">
                                                <QueueSettings />
                                            </Route>
                                        </Switch>
                                    </Route>
                                    <Route path="/jobs">
                                        <Route path="/jobs/auto-file">
                                            <Switch>
                                                <Route path="/jobs/auto-file/status">
                                                    <EFiling />
                                                </Route>
                                                <Route path="/jobs/auto-file/execute">
                                                    <EFiling />
                                                </Route>
                                                <Route path="/jobs/auto-file/analytics">
                                                    <AnalyticsPage />
                                                </Route>
                                            </Switch>
                                        </Route>
                                    </Route>
                                </>
                            )}
                        {(currentUser?.role && portal && (
                            <Route path="/">
                                <TylerFirmsPage />
                            </Route>
                        )) ||
                            (currentUser?.role &&
                                currentUser.role!.key! >= 100 && (
                                    <Route path="/">
                                        <EFiling />
                                    </Route>
                                ))}
                        {currentUser?.role && currentUser.role!.key! < 100 && (
                            <Route path="/">
                                <UploadFile />
                            </Route>
                        )}
                    </Switch>
                </div>
            </div>
        </>
    );
}
